type PageProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

/**
 * A currently empty wrapper component that is intended to provide a uniform styling to all pages, if necessary.
 *
 */
export const Page = (props: PageProps) => (
  <div className="overflow-x-clip" {...props} />
);
